<template>
	<div class="brick">
		<table class="list_tbl">
			<colgroup>
				<col width="10%" />
				<col />
				<col width="10%" />
				<col width="10%" />
				<col width="5%" />
			</colgroup>
			<thead>
				<tr>
					<th>No.</th>
					<th>Title</th>
					<th>Crt User</th>
					<th>Crt Date</th>
					<th>Views</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="notices">
					<tr v-for="notice in notices" v-bind:key="notice.noticeNo">
						<td @click="noticeForm(notice.noticeNo)">{{ notice.noticeNo }}</td>
						<td @click="noticeForm(notice.noticeNo)">{{ notice.subject }}</td>
						<td @click="noticeForm(notice.noticeNo)">{{ notice.crtUser }}</td>
						<td class="al_center" @click="noticeForm(notice.noticeNo)">{{ new Date(notice.crtDt) | dateFormat('MM-DD-YYYY') }}</td>
						<td class="al_right" @click="noticeForm(notice.noticeNo)">{{ notice.views }}</td>
					</tr>
				</template>
			</tbody>
		</table>
		<jpa-paging v-if="page" v-bind:page="page" v-on:gotoPage="gotoPage"></jpa-paging>
		<div class="bottom_bt_box">
			<ul>
				<li><a v-if="session_user.super_admin_yn == 'Y'" href="javascript:;" @click="home">Test</a></li>
				<li><router-link v-if="notice_modify" :to="{ name: 'noticeForm', params: { mode: 'add' } }">Add</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiSelectNotices } from '@/api/basicinfo/notice';
import { apiHome } from '@/api/index';

import JpaPaging from '@/components/common/JpaPaging';

export default {
	name: 'Notices',
	components: { JpaPaging },
	data: function() {
		return {
			notices: {},
			page: undefined,
		};
	},
	computed: {
		session_user() {
			return this.$session.get('user');
		},
		notice_modify() {
			return this.session_user.notice_management || this.session_user.admin_yn === 'Y';
		},
	},

	methods: {
		async home() {
			await apiHome();
		},
		async selectNotices(page, size) {
			const pageNumber = page === undefined ? 0 : page;
			const pageSize = size === undefined ? 20 : size;
			let { data } = await apiSelectNotices({ page: pageNumber, size: pageSize, sort: 'crtDt,desc' });
			this.page = data.page;
			this.notices = this.page.content;
		},
		noticeForm(key) {
			this.$router.push({ name: 'noticeForm', params: { mode: 'detail' }, query: { noticeNo: key } });
		},
		gotoPage(page) {
			this.selectNotices(page);
		},
	},
	created() {
		this.$store.commit('setSubTitle', 'Notice');
		this.selectNotices();
	},
};
</script>

<style scoped></style>
